import { FC } from 'react';
import RatingPlugin from 'react-stars';
import withErrorBoundary from 'components/ui/withErrorBoundaries';

interface RatingProps {
  value: string | number;
  color?: string;
  className?: string;
}

const Rating: FC<RatingProps> = ({ className = '', ...props }) => {
  const colorStar = getComputedStyle(document.body).getPropertyValue('--color-star');
  const colorBorder = getComputedStyle(document.body).getPropertyValue('--color-border');

  return (
    <div className={className}>
      <RatingPlugin
        className="stars flex"
        count={5}
        edit={false}
        size={20}
        color1={colorBorder}
        value={typeof props.value === 'string' ? parseInt(props.value) : props.value}
        color2={props.color || colorStar}
      />
    </div>
  );
};

export default withErrorBoundary(Rating, 'Rating');
